import { Spin } from 'antd'
import { Suspense } from 'react'

import Loading from './index'

function LoadingCenter(props) {
	const { style = {}, bgColor, className } = props
	return (
		<Suspense>
			<div
				className={`flex-center z-[999999] h-screen w-screen ${bgColor ? `bg-[${bgColor}]` : 'bg-transparent'} ${className ?? ''}`}
				style={{ ...style }}
			>
				{props.spin ? <Spin size={props.size} /> : <Loading {...props} />}
			</div>
		</Suspense>
	)
}

export default LoadingCenter
